module.exports = __webpack_public_path__ + "static/img/SALLING_TOPBANNER2.tid5.edbe23f.jpg";